import { notification } from '@pu/mpp-ui/notifications';
import { BANNER_MAP_SPECIFIC_ERROR_CODE_LIST } from 'core/constants/banners.constants';
import type { TCreateBannerParams } from 'core/model/interfaces/banners';
import { IServiceErrorContent } from 'core/model/interfaces/service.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleSpecificErrors } from 'shared/utils/errors.utils';
import { getUnexpectedErrorMessage } from '../banners.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IBannersState } from '../types';

export const createBanner = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/createBanner`,
  async (params: { data: TCreateBannerParams }, { rejectWithValue }) => {
    try {
      const { data } = params;

      await apiService.banners.createBanner(data);

      notification.success('Banner creado correctamente.');
    } catch (error) {
      const handledError = handleSpecificErrors(error, getUnexpectedErrorMessage('drawer', 'create'), [
        ...BANNER_MAP_SPECIFIC_ERROR_CODE_LIST.keys(),
      ]);

      if (handledError) {
        return rejectWithValue(handledError);
      }

      throw error;
    }
  },
);

export const createBannerReducer: TSliceExtraReducer<IBannersState> = builder =>
  builder
    .addCase(createBanner.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(createBanner.rejected, (state, action) => {
      state.form.loading = false;
      state.form.success = false;

      const errorContent = action.payload as IServiceErrorContent<string>;

      BANNER_MAP_SPECIFIC_ERROR_CODE_LIST.forEach((errorKey, errorCode) => {
        if (errorContent?.code === errorCode) {
          state.form.errors[errorKey as string] = errorContent.details.join('\n\n');
        }
      });
    })
    .addCase(createBanner.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
